var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimesheet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7812 5.90625C10.7812 5.54688 11.0957 5.1875 11.5 5.1875C11.8594 5.1875 12.2188 5.54688 12.2188 5.90625V12.0156L16.1719 14.666C16.5312 14.8906 16.6211 15.3398 16.3965 15.6543C16.1719 16.0137 15.7227 16.1035 15.4082 15.8789L11.0957 13.0039C10.8711 12.8691 10.7363 12.6445 10.7363 12.375L10.7812 5.90625ZM11.5 0.875C17.834 0.875 23 6.04102 23 12.375C23 18.7539 17.834 23.875 11.5 23.875C5.12109 23.875 0 18.7539 0 12.375C0 6.04102 5.12109 0.875 11.5 0.875ZM1.4375 12.375C1.4375 17.9453 5.92969 22.4375 11.5 22.4375C17.0254 22.4375 21.5625 17.9453 21.5625 12.375C21.5625 6.84961 17.0254 2.3125 11.5 2.3125C5.92969 2.3125 1.4375 6.84961 1.4375 12.375Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimesheet);
export default __webpack_public_path__ + "static/media/timesheet.1f42be2be8bc12bf7313baca507eb227.svg";
export { ForwardRef as ReactComponent };